import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from './auth.service';
import { EncryptService } from './encrypt.service';
import { PermissionsService } from './permissions.service';
import { AlertService } from './alerts.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private expiracion: Date | undefined;
  // Evita un aviso por cada request que vuelve 401 al mismo tiempo
  private cerrandoSesion = false;
  // Pasa a true cuando el backend aceptó el token en esta carga de la página
  // (login o queryToken OK). Si el token ya estaba vencido al abrir la
  // extranet (ej: token de ayer), se vuelve al login sin el aviso.
  private sesionVerificada = false;

  constructor(
    private enncryptSvc: EncryptService,
    private http: HttpClient,
    private router: Router,
    private alertService: AlertService
  ) {}

  setToken(data: any) {
    const token = data.acceso_token[0].token;
    this.expiracion = new Date(data.acceso_token[0].expira);
    this.cerrandoSesion = false;
    this.sesionVerificada = true;
    localStorage.setItem('token', token);
  }

  getToken() {
    // si no hay token, devuelvo null
    if (!localStorage.getItem('token')) {
      return null;
    }

    // si hay token, devuelvo el token
    return localStorage.getItem('token');
  }

  getAllData() {
    const token = localStorage.getItem('token');
    return this.enncryptSvc.decrypt(token);
  }

  eliminarToken() {
    localStorage.removeItem('token');
  }

  eliminarSessionStorage() {
    sessionStorage.clear();
  }

  // metodo para checkear si el token no expiro
  async checkToken() {
    await this.updateToken();

    if (!this.expiracion) {
      await this.updateToken();
    }

    // si la fecha de expiracion es mayor a la fecha actual por 10 minutos, actualizo el token
    if (this.expiracion && this.expiracion > new Date()) {
      if (this.expiracion.getTime() - new Date().getTime() < 600000) {
        await this.updateToken();
      }
    }

    // si la fecha de expiracion es menor a la fecha actual, deslogueo al usuario
    if (this.expiracion && this.expiracion < new Date()) {
      this.logOut();
    }
  }

  async updateToken() {
    const headers = this.getHttpHeaders();
    return new Promise((resolve, reject) => {
      this.http
        .get('/cgi-bin/wspd_cgi.sh/WService=api/queryToken.r', {
          headers: headers,
        })
        .subscribe(
          (data: any) => {
            this.expiracion = new Date(data.acceso_token[0].expira);
            this.sesionVerificada = true;
            resolve(this.expiracion);
          },
          (err) => {
            //si el token no es valido, deslogueo al usuario
            this.logOut();
            // Resolver igual: si la promesa queda pendiente, el guard que la espera queda colgado
            resolve(null);
          }
        );
    });
  }

  getHttpHeaders(): HttpHeaders {
    const token = this.getToken() || '';
    const headers = new HttpHeaders().set('token', token);
    // const headers = new HttpHeaders().set(
    //   'token',
    //   'e3144d79f931b3f5441010e73f72acea59b92545'
    // );
    return headers;
  }

  logOut() {
    if (this.cerrandoSesion) {
      return;
    }
    this.cerrandoSesion = true;
    if (this.sesionVerificada) {
      this.alertService.error({
        title: 'Oops...',
        text: 'Su sesión ha expirado o ha iniciado sesion en un dispositivo diferente, por favor vuelva a iniciar sesión.',
        showConfirmButton: true,
      });
    }
    this.sesionVerificada = false;
    this.eliminarToken();
    this.eliminarSessionStorage();
    this.router.navigate(['/auth/login']);
  }
}
